import React from 'react';
import './HomePage.css'; // Подключение стилей

const HomePage = () => {
    return (
        <div className="home-page">
            <h1 className="neon-text">Welcome to <span class="fast-flicker">M</span>INTSK<span class="flicker">O</span>PLENOK</h1>  
   </div>
    );
};

export default HomePage;
